import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, Mail, Phone, MapPin, Linkedin } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import { createPageUrl } from '@/utils';

export default function Footer() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };
  const navigation = [
    { name: 'Home', id: 'home' },
    {
      name: 'About',
      id: 'about',
      // submenu: [
      //   { name: 'About Us', id: 'about' },
      //   { name: 'Vision & Mission', id: 'vision-mission' },
      //   { name: 'Testimonials', id: 'testimonials' }
      // ]
    },
    { name: 'Services', id: 'services' },
    // { name: 'Portfolio', id: 'portfolio' },
    { name: 'FAQ', id: 'faq' },
    { name: 'Contact', id: 'contact' }
  ];
  return (
    <footer className="bg-gradient-to-br from-purple-900 via-purple-800 to-pink-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">
          {/* Brand */}
          {/* <div className="space-y-4">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-white to-amber-400 bg-clip-text text-transparent">
                Restorative Connections
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                Creating extraordinary digital experiences with elegance and precision.
              </p>
            </div> */}

          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 px-2 mb-5
           ">
              <div className="w-40 h-14 rounded-xl  px-1 overflow-hidden">
                <img
                  // src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=100&h=100&fit=crop"
                  src="/images/rclogo2.png"
                  alt="Restorative Connections"
                  className="w-full h-full object-cover bg-blue-200 rounded-xl pr-1"
                />
              </div>
              {/* <span className="text-2xl font-bold">Restorative Connections</span> */}

            </div>
            <p className="text-gray-400 pl-2 leading-relaxed mb-8 max-w-md">
              Empowering you to live your healthiest, most vibrant life through Restorative therapy programs
              and personalized Nursing care.
            </p>


          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              {navigation.map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-amber-400">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-amber-400" />
                {/* info@restorativeconnections.ca */}
                <a href="mailto:info@restorativeconnections.ca" className="text-slate-400 hover:text-amber-400 transition-colors">
                  info@restorativeconnections.ca
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-amber-400" />
                {/* +1 (647) 839-6515 */}
                <a href="tel:+1647839-6515" className="text-slate-400 hover:text-amber-400 transition-colors">
                  +1 (647) 839-6515
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-amber-400" />
                3850 Finch Avenue East, Suite 306,
              </li>
              <span className="p-7 text-slate-400 text-sm">
                Scarborough, Ontario, M1T 3T6
              </span>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-semibold mb-4 text-amber-400">Follow Us</h4>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/profile.php?id=61584313253773"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-amber-500 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © 2025 Restorative Connections. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}